import { Paper, Typography, Stack, Grid, Link } from "@mui/material";
import { Room, Phone } from "@mui/icons-material";

import LabeledText from "components/Common/LabeledText";

import useTranslations from "helpers/hooks/useTranslations";
import useOrderData from "components/Orders/useOrderData";

import Format from "helpers/fv.format";

function BillingCard() {
    const tm = useTranslations();
    const { order } = useOrderData();

    return <>
        <Paper sx={{display: "flex", width: "100%"}}>
            <Stack display="flex" width="100%" m={1}>
                <Grid container direction="row">
                    <Grid item xs display="flex" alignItems="center">
                        <Typography variant="h6">
                            {tm.Get("Billing")}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container mt={1}>
                    <Grid item mr={1}>
                        <Room color="primary"/>
                    </Grid>
                    <Grid item xs>
                        <Typography>
                            {order?.billing?.name ?? ""}
                            <br />
                            {order?.billing?.address?.address1 ?? ""}
                            <br />
                            {order?.billing?.address?.address2 ?? ""}
                            <br />
                            {Format.FormatCityStateZip(order?.billing?.address?.city ?? "", order?.billing?.address?.state ?? "", order?.billing?.address?.zipCode ?? "")}
                            <br />
                            {order?.billing?.address?.country ?? ""}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container mt={1} direction="row">
                    <Grid item mr={1} display="flex" alignItems="center">
                        <Phone color="primary"/>
                    </Grid>
                    <Grid item xs display="flex" alignItems="center">
                        <LabeledText label={tm.Get("Phone")} text={
                            <Link href={`tel:${order?.billing?.phone ?? ""}`} underline="always" tabIndex={(order?.billing?.phone ?? "") === "" ? -1 : undefined}>
                                {order?.billing?.phone ?? ""}
                            </Link>
                        } />
                    </Grid>
                </Grid>

                {order?.billing?.fax &&
                    <Grid container mt={1} direction="row">
                        <Grid item mr={1} display="flex" alignItems="center">
                            <Phone opacity={0} />
                        </Grid>
                        <Grid item xs display="flex" alignItems="center">
                            <LabeledText label={tm.Get("Fax")} text={order.billing.fax} />
                        </Grid>
                    </Grid>
                }

            </Stack>
        </Paper>

    </>

}


export default BillingCard;